module.exports = __webpack_public_path__ + "index-banner-m-new.jpg?a771d1b04f378a43451a456de8c9cf31";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index-banner-m-new.jpg
// module id = 91
// module chunks = 0